import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Message from './Message';
import MessageModal from './MessageModal';

import { messageTypes } from 'constants/values';

// Lodash
import compact from 'lodash/compact';
import get from 'lodash/get';
import uniq from 'lodash/uniq';

/** Displays toast and modal messages.
 */
class MessagePanel extends Component {

  _onMessageClosed(messageId) {
    this.props.closeMessage(messageId);
  }

  render() {
    // If there are any modal messages, just show the first one.
    const modalMessage = this.props.messages.find( (message) => message.type === messageTypes.MODAL );
    if (modalMessage) {
      return (
        <MessageModal
          blocking={modalMessage.blocking}
          bodyHtmlMessageKey={modalMessage.bodyHtmlMessageKey}
          bodyHtmlMessageParams={modalMessage.bodyHtmlMessageParams}
          buttons={modalMessage.buttons}
          className={modalMessage.className}
          footerText={modalMessage.footerText}
          name={modalMessage.name}
          provideCloseButton={modalMessage.provideCloseButton}
          title={modalMessage.title}
        />
      );
    }

    const uniqueMessages = compact(uniq(this.props.messages, function(message) {
      return message.text;
    }));

    if (!uniqueMessages.length) {
      return null;
    }
    const messages = uniqueMessages.map((message, index) => {
      return index === 0 ? (
        <Message
          buttons={message.buttons}
          id={message.id}
          index={index}
          key={index}
          onClose={get(message, 'buttons[0].onClick', this._onMessageClosed.bind(this))}
          showDismiss={message.showDismiss}
          testId={message.testId}
          text={message.text}
          title={message.title}
          toast={message.toast}
          type={message.type}
        />
      ) : null;
    });

    const messagePanelClassString = classNames({
      'vra-message-panel': true
    });
    return (
      <section
        className={ messagePanelClassString }
        data-test-id='vra-message-panel'
      >
        {messages}
      </section>
    );
  }
}

MessagePanel.propTypes = {
  closeMessage: PropTypes.func.isRequired,
  // Set isToolbarShown to true if toolbar occupies part of message panel area. Layout
  // will be adjusted so that toast messages don't appear over it.
  isToolbarShown: PropTypes.bool,
  messages: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default MessagePanel;
